import { useEffect } from 'react'
import { Table } from '@tanstack/react-table'
import { Log } from '@/types/logs'

export const useLeaveSiteAlert = ({
    table,
    isCreateFormActive,
}: {
    table: Table<Log>
    isCreateFormActive: boolean
}) => {
    const rowSelectionLength = Object.keys(table.getState().rowSelection).length
    useEffect(() => {
        const handleBeforeUnload = (event: BeforeUnloadEvent) => {
            if (rowSelectionLength !== 0 || isCreateFormActive) {
                event.preventDefault()
                event.returnValue = 'Leave site? Changes that you made may not be saved.'
                // The string is required for some browsers, but most will show a generic message
            }
        }

        window.addEventListener('beforeunload', handleBeforeUnload)

        return () => {
            window.removeEventListener('beforeunload', handleBeforeUnload)
        }
    }, [rowSelectionLength, isCreateFormActive])
}
